"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _omit = require("lodash/fp/omit");

var _omit2 = _interopRequireDefault(_omit);

var _pick = require("lodash/fp/pick");

var _pick2 = _interopRequireDefault(_pick);

var _pickBy = require("lodash/fp/pickBy");

var _pickBy2 = _interopRequireDefault(_pickBy);

var _flattenDeep = require("lodash/fp/flattenDeep");

var _flattenDeep2 = _interopRequireDefault(_flattenDeep);

var _mapValues = require("lodash/mapValues");

var _mapValues2 = _interopRequireDefault(_mapValues);

var _deepmerge = require("deepmerge");

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pickTruthty = (0, _pickBy2.default)(Boolean);

function getDisplayName(Component) {
    if (typeof Component === "string") {
        return Component;
    }

    return Component.displayName || Component.name || "Anonymous";
}

function mergeAlts(parent, current) {
    var alts = {};

    Object.keys(parent).forEach(function (key) {
        alts[key] = parent[key];
    });

    Object.keys(current).forEach(function (key) {
        alts[key] = (0, _flattenDeep2.default)([alts[key], current[key]]).filter(Boolean);
    });

    return alts;
}

var createSimple = function createSimple(createRule, render) {
    return function simple(Component, styles) {
        var alts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (Component._styleWrapped) {
            var parentAlts = Component._styleWrapped.alts;

            return simple(Component._styleWrapped.Component, (0, _flattenDeep2.default)([Component._styleWrapped.styles, styles]), mergeAlts(parentAlts, alts));
        }

        var rules = { __base: createRule((0, _flattenDeep2.default)([styles])) };

        var altProps = Object.keys(alts);

        for (var key in alts) {
            rules[key] = createRule((0, _flattenDeep2.default)([styles, alts[key]]));
        }

        function Simple(props) {
            var passProps = (0, _omit2.default)(altProps, props);
            var alt = Object.keys(pickTruthty((0, _pick2.default)(altProps, props)));

            if (alt.length > 1) {
                throw new Error("Too many alt props: " + alt.join(", "));
            }

            var rule = rules[alt[0] || "__base"];

            return render(Simple, Component, rule, passProps, alt[0]);
        }

        Simple._styleWrapped = {
            Component: Component,
            styles: styles,
            alts: alts
        };

        Simple.displayName = "simple(" + getDisplayName(Component) + ")";

        Simple.create = function (el) {
            return simple(el, styles, alts);
        };

        return Simple;
    };
};

exports.default = createSimple;